"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _PyramIcon = createIcon({
  displayName: "_PyramIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m250.011 71.163c20.532 35.558 40.61 70.329 60.917 105.497-40.682 0-80.999 0-121.824 0 20.215-35.015 40.325-69.848 60.907-105.497z"
        fill="currentColor"
      />
      <path
        d="m98.746 333.155c20.443 35.413 40.466 70.099 60.748 105.233-40.658 0-80.703 0-121.493 0 20.275-35.124 40.326-69.861 60.745-105.233z"
        fill="currentColor"
      />
      <path
        d="m401.275 333.155c20.408 35.349 40.43 70.036 60.725 105.19-40.625 0-80.668 0-121.439 0 20.216-35.027 40.267-69.765 60.714-105.19z"
        fill="currentColor"
      />
      <path
        d="m189.235 438.43c20.374-35.287 40.388-69.953 60.733-105.188 20.383 35.302 40.432 70.026 60.732 105.188-40.684 0-80.713 0-121.465 0z"
        fill="currentColor"
      />
      <path
        d="m189.222 193.807h121.481c-20.283 35.137-40.336 69.875-60.733 105.213-20.347-35.242-40.372-69.922-60.748-105.213z"
        fill="currentColor"
      />
      <path
        d="m264.949 307.287c20.256-35.079 40.248-69.701 60.699-105.119 20.459 35.437 40.449 70.061 60.688 105.119-40.684 0-80.705 0-121.387 0z"
        fill="currentColor"
      />
      <path
        d="m325.604 430.023c-20.439-35.398-40.402-69.979-60.631-105.014h121.252c-20.19 34.971-40.155 69.557-60.621 105.014z"
        fill="currentColor"
      />
      <path
        d="m235.007 307.329c-40.677 0-80.64 0-121.344 0 20.236-35.051 40.229-69.681 60.671-105.088 20.427 35.38 40.421 70.01 60.673 105.088z"
        fill="currentColor"
      />
      <path
        d="m113.753 324.944h121.242c-20.21 35.009-40.162 69.573-60.61 104.995-20.35-35.242-40.335-69.849-60.632-104.995z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _PyramIcon;
